// The Help Centre in Chinese (Simplified): the wording around the translated pages (chapter names, search result
// labels, the note on a page that isn't translated yet). The pages themselves are Markdown in help/zh/ (same paths as
// the English in help/), and the quick-start guides are in helpguide-zh.ts. Chapter names match the screens' wording
// (web/public/i18n/zh.json).
export const CHAPTER_TITLES_ZH: Record<string, string> = {
  "getting-started": "入门",
  dashboard: "仪表板和我的任务",
  development: "开发 – 研发、工艺单、图案库",
  products: "产品——服装、面料、辅料",
  "purchase-orders": "采购订单",
  "critical-path": "生产进度计划 (T&A)",
  sampling: "打样",
  quality: "质量——质检与合规",
  logistics: "物流",
  inventory: "库存",
  finance: "财务",
  partners: "合作伙伴",
  reports: "报表",
  crm: "Falcon CRM（客户管理）",
  settings: "设置",
  account: "账户和安全",
  general: "打印、导出和搜索",
  support: "帮助和支持",
};
export const HELP_WORDS_ZH = {
  guide: "快速入门指南",
  whatsNew: "新功能",
  guideHeadings: ["入门步骤", "订单流程", "各项内容在哪里"],
  guideKeywords: ["快速入门", "入门"],
  /** Search results (the results list is never translated on screen, so its wording is here). */
  kinds: { manual: "用户手册", guide: "快速入门指南", whatsnew: "新功能" } as Record<string, string>,
  results: (n: number, q: string) => `“${q}”的搜索结果：${n} 个`,
  nothing: (q: string) => `没有找到“${q}”的结果。请换个词试试，或`,
  contactSupport: "联系支持",
  /** Inside the "?" side panel (never translated on screen, so its wording is here). */
  /** Under Contact support: the support email address. */
  preferEmail: "更喜欢用电子邮件？请写信至",
  related: "相关页面", helpful: "此页面有帮助吗？", yes: "是", no: "否", openFull: "以完整页面打开", contactSupportCap: "联系支持",
  /** Shown at the top of a page (or What's new entry) that has no Chinese version yet. */
  notTranslated: "此页面还没有中文版本，暂时以英文显示。",
};
